import { Component, OnInit, signal } from '@angular/core';
import { BleachrLinkGenerator } from 'src/app/_classes/bleachr-link';
import { AnalyticsService, EnhancedArticlesService, RouteParserService } from 'src/app/_services';
import { EnhancedArticlesComponent } from 'src/app/_modules/enhanced-articles/enhanced-articles.component';
import { EnhancedArticle } from 'src/app/_interfaces';
import { NewTypes } from '../news-section.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';
import { SponsorBannerComponent } from '../../_modules/sponsor-banner/sponsor-banner.component';
import { DatePipe } from '@angular/common';
import { ImageComponent } from '../../_modules/image/image.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SsrlocalstoreService } from 'src/app/_services/ssr-localstore.service';
import { LoadingIndicatorComponent } from 'src/app/_modules/loading-indicator/loading-indicator.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { IntersectionObserverDirective } from 'src/app/_directives/intersection-observer.directive';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    imports: [SponsorBannerComponent, ImageComponent, MatButton, MatIcon, DatePipe, LoadingIndicatorComponent, IntersectionObserverDirective]
})
export class NewsComponent implements OnInit {
    public type: NewTypes = 'all';
    public listener: any;
    public article: EnhancedArticle = {} as EnhancedArticle;
    public news_articles = signal<EnhancedArticle[]>([]);
    public page = signal(0);

    isVisible = signal(false);
    completed = signal(false);

    constructor(
        private routeParser: RouteParserService,
        private dialog: MatDialog,
        private articleService: EnhancedArticlesService,
        private analyticsService: AnalyticsService,
        private toastr: ToastrService,
        private clipboard: Clipboard,
        private ssr: SsrlocalstoreService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    async ngOnInit() {
        this.type = this.route.snapshot.routeConfig?.path ? (this.route.snapshot.routeConfig?.path as NewTypes) : 'all';
        await this.handleNewsArticle();
    }

    get current_fan_id() {
        let fan_id;
        if (this.ssr.getItem(`golfOne`)) {
            const fan_meta = this.ssr.getItem(`golfOne`) as string;
            fan_id = JSON.parse(fan_meta).user.fan_id;
        }
        return fan_id ? fan_id : ``;
    }

    handleType(type: string) {
        const tidy_text = type.toUpperCase().replace('_', ' ');
        return type === 'videos' ? tidy_text.substring(0, type.length - 1) : tidy_text;
    }

    async getArticleById(articleId: string): Promise<EnhancedArticle | null> {
        try {
            if (articleId) {
                this.article = (await this.articleService.getArticleById(articleId)) || ({} as EnhancedArticle);
                return this.article;
            }
            return null;
        } catch (e) {
            return null;
        }
    }

    async openLink(item: EnhancedArticle): Promise<void> {
        const url = new BleachrLinkGenerator().enhancedArticle(item.id);

        let show_ad_before_articles: boolean = false;
        if (item?.id) show_ad_before_articles = (await this.getArticleById(item.id))?.contributor?.show_ad_before_articles ?? false;
        const iframe_data = await this.routeParser.parseBleachrRoutes(url, show_ad_before_articles);

        if (iframe_data) {
            const view_payload = {
                article_id: this.article.id,
                contributor_id: this.article.contributor.id,
                viewed_from_source: 'news_page',
                source: {}
            };
            this.analyticsService.postEvent('article_viewed', view_payload);
            this.dialog.open(EnhancedArticlesComponent, {
                data: { iframe_data },
                width: '90vw',
                height: '90vh'
            });
        }
    }

    async handleNewsArticle(visable?: boolean) {
        try {
            if (this.ssr.isClientSide && visable && !this.completed()) {
                await this.articleService
                    .getArticles(this.page(), this.type)
                    .then((res) => {
                        if (res.length <= 0) {
                            this.completed.set(true);
                            return;
                        }
                        if (this.news_articles().length <= 0) {
                            this.news_articles.set(res);
                        } else if (this.news_articles().length > 0) {
                            this.news_articles.update((current) => [...current, ...res]);
                        }
                        this.page.update((current) => current + 1);
                        return;
                    })
                    .catch((err) => {
                        throw err;
                    });
            }
        } catch (err) {
            console.error(err);
            throw err;
        }
    }

    shareArticle(e: Event, article: any) {
        e.stopPropagation();

        const link = `${environment.NEWS_HOST}/article/${article.id}`;

        this.clipboard.copy(link);
        this.toastr.info('Link Copied');
    }
}
